import { render, staticRenderFns } from "./ComponentFooter.vue?vue&type=template&id=5dd29105&scoped=true&"
import script from "./ComponentFooter.vue?vue&type=script&lang=js&"
export * from "./ComponentFooter.vue?vue&type=script&lang=js&"
import style0 from "./ComponentFooter.vue?vue&type=style&index=0&id=5dd29105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd29105",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
